'use client';

import '@rainbow-me/rainbowkit/styles.css';

import {
  ConnectButton,
  darkTheme,
  lightTheme,
  RainbowKitAuthenticationProvider,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import { useRouter } from 'next/navigation';
import toast from 'react-hot-toast';
import { authenticationAdapter } from '../authentication-adapter';
import { Web3SignInProps } from './Web3SignInProps';
import { loginWithEth } from '../login-methods';

export { type RainbowKitTheme } from './rainbow-kit-theme';

export function Web3SignIn({
  locale,
  appInfo,
  signMessage,
  theme = {
    color: 'light',
    accentColor: '#CFB16D',
    accentColorForeground: 'black',
    borderRadius: 'small',
  },
  t,
  redirectAfterSuccess,
}: Web3SignInProps) {
  const { replace } = useRouter();

  return (
    <RainbowKitAuthenticationProvider
      adapter={authenticationAdapter({
        locale,
        signMessage,
        onSuccess: replace,
        onError: (error) => toast.error(error.message),
        loginAction: loginWithEth.bind(null, redirectAfterSuccess),
      })}
      status={'unauthenticated'}
    >
      <RainbowKitProvider
        theme={
          theme.color === 'light'
            ? lightTheme({
                accentColor: theme.accentColor,
                accentColorForeground: theme.accentColorForeground,
                borderRadius: theme.borderRadius,
                fontStack: 'system',
              })
            : darkTheme({
                accentColor: theme.accentColor,
                accentColorForeground: theme.accentColorForeground,
                borderRadius: theme.borderRadius,
                fontStack: 'system',
              })
        }
        appInfo={appInfo}
      >
        <div className="wallet-connect-container flex w-full flex-col items-center justify-center gap-3">
          <ConnectButton label={t.connectWallet} />
          <span className="text-xs font-bold">{t.info}</span>
        </div>
      </RainbowKitProvider>
    </RainbowKitAuthenticationProvider>
  );
}
